import React, { useEffect, useState } from 'react'
import { useNewsTypeListQuery } from '../../store/ReactWebSiteApi';
import { Form, Select } from 'antd';

function NewsTypeForm(props) {
    const {data:dataType,isSuccess:isSuccessType} = useNewsTypeListQuery({ent_e_id:localStorage.getItem('e_id')})
    const [options, setOptions] = useState();
    useEffect(() => {
         if(isSuccessType){            
             if(dataType.Status==='success'){
                 // console.log(dataType);
                 
                 const newArr = dataType.Result.map(item => {
                     const {ent_id:key,ent_name,} = item;
                     return item = {value:key,label:ent_name}
                 })   
                 setOptions(newArr)
             }else{
                 setOptions('')
             }
             
         }
     }, [dataType, isSuccessType])      
     
    return (
        <Form.Item 
            label='新闻类型'
            name={props.name}
            wrapperCol={props.wrapperCol}
            required={props.required}
            style={props.style}
        
        >
            <Select 
                options={options}  
                allowClear
                onClear={(e) => {
                    console.log(e);
                    props.onClear()
                }}
                onChange={(e,f) => {
                    if(f){
                        props.onChange(e,f.label)
                    }
                }}
            />                                
        </Form.Item>
    )
}

export default NewsTypeForm